import { useTranslation } from "react-i18next";
import { ButtonContainer } from "./Components";


export default function PrimaryButton({children, full, submitting, submitLabel, ...props}){
    const {t} = useTranslation();
    return (
        <ButtonContainer variant="primary" className={full?"full":""} {...props} disabled={submitting?true:props.disabled}>
            {submitting?(submitLabel??t("Submitting...")):children}
        </ButtonContainer>
    )
}